import React from 'react'
import errorImage from '../../../images/error.gif';


const ErrorPage = () => {
  return (
    <>
      <div className="container">
        <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
          <div className="d-flex justify-content-between align-items-center flex-column gap-4 pt-5 text-center">
            <h1 className="title-font-bold text-base-color fs-128">404</h1>
            <h2 className="title-font-600 fs-48">Page Not Found</h2>
            <h6 className="base-font-600 text-base-gray fs-32 text-center">Sorry,The page you are looking for does not exist  .....</h6>
            <img src={errorImage} alt="Error" className=''/>
          </div>
        </div>
      </div>
    </>
  )
}

export default ErrorPage